(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@dark-engine/core"));
	else if(typeof define === 'function' && define.amd)
		define("DarkData", ["@dark-engine/core"], factory);
	else if(typeof exports === 'object')
		exports["DarkData"] = factory(require("@dark-engine/core"));
	else
		root["DarkData"] = factory(root["DarkCore"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__317__) => {
return 